import styled from 'styled-components';
import ScrollToTop from '@utils/scrollToTop';
import { useLocation } from 'react-router-dom';
import { useDocTitle } from '@hooks/useDocTitle';
import { ENV } from '@configs/env';
import { OutsideContainer, OutsideLayoutContent, OutsideContent } from './style';
import {
    BannerPanel,
    LogoImage,
    IconWrapper,
    FormWrapper,
    FormInner,
    BannerHeadline,
    BannerSubheadline,
} from '@/pages/style';

const CENTERED_AUTH_PATHS = [
    '/sign-in',
    '/sign-up',
    '/verify-email',
    '/onboarding',
    '/forgot-password',
    '/otp',
    '/reset-password',
    '/accept-invite',
    '/accept-client-invitation',
];

const FullWidthWrapper = styled.div`
    width: 100%;
    min-height: 100vh;
    position: relative;
`;

const Outside = ({ children }) => {
    const location = useLocation();
    useDocTitle({ location });
    const isCentered = CENTERED_AUTH_PATHS.includes(location.pathname);
    const isOnboarding = location.pathname === '/onboarding';
    const appName = ENV.APP_NAME || 'Project Name';
    const productLogoPath = ENV.PRODUCT_LOGO_PATH || '/logo.png';

    return (
        <>
            <ScrollToTop />
            <OutsideContainer>
                <OutsideLayoutContent>
                    {isOnboarding ? (
                        <FullWidthWrapper>{children}</FullWidthWrapper>
                    ) : (
                        <OutsideContent $centered={isCentered}>
                            {!isCentered && (
                                <IconWrapper>
                                    <BannerPanel>
                                        <LogoImage src={productLogoPath} alt={`${appName} logo`} />
                                        <BannerHeadline>{`Welcome to ${appName}`}</BannerHeadline>
                                        <BannerSubheadline>
                                            Manage your shipments, fleet, and warehouse in one smart dashboard.
                                        </BannerSubheadline>
                                    </BannerPanel>
                                </IconWrapper>
                            )}
                            <FormWrapper $centered={isCentered}>
                                <FormInner>{children}</FormInner>
                            </FormWrapper>
                        </OutsideContent>
                    )}
                </OutsideLayoutContent>
            </OutsideContainer>
        </>
    );
};

export default Outside;
